<template>
  <span>
    <button type="button" class="btn btn-danger btn-xs mr-1" @click="toggle"><i class="fas fa-trash"></i>&nbsp;Remove</button>

    <b-modal
        @show="resetModal"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        title="Confirm remove?"
        hide-footer
    >
      <span>
        {{ message }}: <b>{{ object }}</b>.
      </span>
      <b-button class="mt-2 float-right" variant="danger" @click="handleSubmit">Remove</b-button>
    </b-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false,
    }
  },
  components: {
  },
  props: [
      'object',
      'message',
      'url',
      'removeHandler'
  ],
  methods: {
    resetModal() {
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      if (this.removeHandler) {
        this.removeHandler(this)
        return;
      }

      this
          .$http({
            url: this.url,
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish')
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          });
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
}
</script>
